import React from 'react';

export default function SuccessPage() {
  return (
    <div id="error-page">
      <h1>Danke!</h1>
      <p>Ihre Bewertung ist bei uns eingegangen.</p>
    </div>
  );
}